import { render, staticRenderFns } from "./ApproveForm.vue?vue&type=template&id=78d9461e"
import script from "./ApproveForm.vue?vue&type=script&lang=js"
export * from "./ApproveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports